import { fromFetch } from 'rxjs/fetch';

import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { routingProfileServiceEnvironment } from '../routing-profile-service-environment';
import { routingProfileSchema } from '../schemas/routing-profile.schema';

/**
 * Get all routing profiles within the account
 * @param params Paged Collection Params
 * @returns A paged collection of Routing Profiles
 */
export function getRoutingProfiles(
  this: unknown,
  params?: PagedCollectionParams
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${routingProfileServiceEnvironment.resolve(this).routingProfilesUrl}${
          params ? `?${params.urlParams}` : ''
        }`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(createPagedCollectionSchema(routingProfileSchema)));
}
